//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    ACCOUNTS_GET_ACCOUNT_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    accountsGetDetailsAccountResult,
} from 'Redux/actions';

function* getCompany({ payload }) {
    try {
        let QUERY = `
            query getCompany ($id: Int!) {
                result: getCompany (id: $id) {
                    id
                    dealerId
                    name
                    status
                    language
                    timezone
                    timezoneId
                    roleId
                    customRoleId
                    username
                    email
                    sm
                    internal
                    cognitoAuth
                    crmId
                    dealer {
                        id
                        name
                        masterCompanyId
                        email
                        username
                    }
                    devicesCount
                    hasPromiles
                    compdata {
                        promiles
                        promilesLogin
                        promilesEmail
                        fuelCardCompanyCode
                    }
                    createdBy
                    createdOn
                    updatedBy
                    updatedOn
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
               id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if(data?.result){
            yield put(accountsGetDetailsAccountResult(data?.result))
        }

    } catch (exc) {
        yield put(accountsGetDetailsAccountResult(null))
        ExceptionManager(exc, 'Modules/accounts/views/main/.components/details/redux/saga', 'getCompany');
    }
}

function* watchCatalogRequests() {
    yield takeEvery(ACCOUNTS_GET_ACCOUNT_REQUEST, getCompany);
}


//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchCatalogRequests)
    ]);
}